import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '👨',
    title: 'pages.quizOnboarding.gender.answer1',
    value: 'male',
  },
  {
    emoji: '👩',
    title: 'pages.quizOnboarding.gender.answer2',
    value: 'female',
  },
]

export default function GenderPage() {
  return (
    <QuizChoicePage
      answers={answers}
      title="pages.quizOnboarding.gender.title"
    />
  )
}
